export default __webpack_public_path__ + "static/media/ic_thunderstorm.8361ab42.svg";